export const dataBusinessTypeList = [
    {
        label: 'PC网页取证',
        value: 1,
        sourceType: 955740,
    },
    {
        label: '网页取证增强版',
        value: 2,
        sourceType: 955740,
    },
    {
        label: 'PC录屏取证',
        value: 4,
        sourceType: 955740,
    },
    {
        label: '境外取证',
        value: 5,
        sourceType: 955740,
    },
    {
        label: '音视频自动取证',
        value: 6,
        sourceType: 955740,
    },
    {
        label: '直播自动取证',
        value: 7,
        sourceType: 955740,
    },
    {
        label: '微信公众号取证',
        value: 8,
        sourceType: 955740,
    },
    {
        label: '录像取证',
        value: 9,
        sourceType: 954210,
    },
    {
        label: '录音取证',
        value: 10,
        sourceType: 954210,
    },
    {
        label: '手机录屏取证',
        value: 11,
        sourceType: 954210,
    },
    {
        label: '手机网页取证',
        value: 12,
        sourceType: 954210,
    },
    {
        label: '拍照取证',
        value: 13,
        sourceType: 954210,
    },
    {
        // label: '版权（著作权）确权',
        label: '版权保护',
        value: 14,
        sourceType: 952310,
    },
    {
        label: '商业秘密存证',
        value: 15,
        sourceType: 952310,
    },
    {
        label: '商标/专利存证',
        value: 16,
        sourceType: 952310,
    },
    {
        label: '数据资产存证',
        value: 17,
        sourceType: 952310,
    },
    {
        label: '软件项目存证',
        value: 18,
        sourceType: 952310,
    },
    {
        label: '工业项目存证',
        value: 19,
        sourceType: 952310,
    },
    {
        label: '硬件项目存证',
        value: 20,
        sourceType: 952310,
    },
    {
        label: '科研成果存证',
        value: 21,
        sourceType: 952310,
    },
    {
        label: 'AIGC',
        value: 24,
        sourceType: 700028,
    },
    {
        label: '邮件认证',
        value: 22,
        sourceType: 700025,
    },
    {
        label: '其他',
        value: 23,
        sourceType: 952310,
    },
]

export const dataBusinessTypeFilter = (value) => {
    const obj = dataBusinessTypeList.find(item => item.value === value)
    return obj ? obj.label : '-'
}